import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Space, message } from 'antd';
import { PrinterOutlined, CloseOutlined } from '@ant-design/icons';
import { generateReceiptHTML } from '../../services/receiptGenerator';
import './ReceiptPreview.css';

const ReceiptPreview = ({ open, onClose, invoice, accountSettings }) => {
  const iframeRef = useRef(null);
  const [receiptHtml, setReceiptHtml] = useState('');

  useEffect(() => {
    if (open && invoice) {
      const html = generateReceiptHTML(invoice, accountSettings);
      setReceiptHtml(html);
    }
  }, [open, invoice, accountSettings]);

  const handlePrint = () => {
    try {
      const iframe = iframeRef.current;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        message.success('Print dialog opened');
      }
    } catch (error) {
      console.error('Print error:', error);
      message.error('Failed to open print dialog');
    }
  };

  const handleClose = () => {
    setReceiptHtml('');
    onClose();
  };

  return (
    <Modal
      title="58mm Thermal Receipt Preview"
      open={open}
      onCancel={handleClose}
      width={400}
      centered
      footer={[
        <Button key="close" icon={<CloseOutlined />} onClick={handleClose}>
          Close
        </Button>,
        <Button
          key="print"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrint}
        >
          Print Receipt
        </Button>,
      ]}
    >
      <div className="receipt-preview-container">
        <div className="receipt-preview-wrapper">
          {receiptHtml && (
            <iframe
              ref={iframeRef}
              srcDoc={receiptHtml}
              title="Receipt Preview"
              className="receipt-preview-iframe"
            />
          )}
        </div>
        <div className="receipt-preview-hint">
          <Space direction="vertical" size={4} style={{ textAlign: 'center', width: '100%' }}>
            <span>Preview shown at actual 58mm width</span>
            <span style={{ fontSize: 11, color: '#888' }}>
              Select your thermal printer in the print dialog
            </span>
          </Space>
        </div>
      </div>
    </Modal>
  );
};

export default ReceiptPreview;
